// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__2mQNZ","insightsList":"newBusinessInsightsMenu_insightsList__2dXcX","active":"newBusinessInsightsMenu_active__1nGsI"};